import { ApolloError, gql, useQuery } from '@apollo/client';

import { Server } from '../../apollo/types';
import { Maybe } from '../../types';
import { GetIntentionQuery, GetIntentionQueryVariables, GetIntention__CurrentSessionIntention } from './types';

const GET_CURRENT_INTENTION_QUERY = gql`
  query GetIntention(
    $clientUserShortId: String!
    $providerShortId: String!
    $status: IntentionCheckInStatusFilter = COMPLETED
  ) {
    intentionHistory(clientUserShortId: $clientUserShortId, providerShortId: $providerShortId) {
      currentSessionIntention {
        shortId
        contentText
        checkIns(status: $status) {
          shortId
          completedAt
          outcome {
            outcome
            label
          }
          options {
            label
            outcome
          }
        }
      }
    }
  }
`;

interface GetIntentionQueryResponse {
  loading: boolean;
  error?: ApolloError;
  currentIntention?: Maybe<GetIntention__CurrentSessionIntention>;
}

export function useGetIntentionQuery(clientUserShortId: string, providerShortId: string): GetIntentionQueryResponse {
  const { data, loading, error } = useQuery<GetIntentionQuery, GetIntentionQueryVariables>(
    GET_CURRENT_INTENTION_QUERY,
    {
      variables: { clientUserShortId, providerShortId },
      skip: !providerShortId || !clientUserShortId,
      context: {
        server: Server.MONOLITH,
      },
    },
  );
  return {
    loading,
    error,
    currentIntention: data?.intentionHistory?.currentSessionIntention,
  };
}
